import { MapPdfSummaryComponent } from '~/map/page/mapPdfSummary.component';

type PdfReportPageProps = Readonly<{
  mapId: number;
}>;

export const ReportPageComponent = (props: PdfReportPageProps) => {
  return (
    <div>
      <div>PDF report for mapId: {props.mapId}</div>
      <MapPdfSummaryComponent />
    </div>
  );
};
